var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-register-audit" }, [
    _c(
      "div",
      { staticClass: "standard-size-16 color-gray-10" },
      [
        _c("div", { staticClass: "font-bolder" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_sd_register_attribute" /**注册属性 */)) +
              "\n    "
          ),
        ]),
        _c(
          "yxtf-row",
          { staticClass: "mv24 font-normal font-size-14" },
          _vm._l(_vm.fields, function (item, index) {
            return _c(
              "yxtf-col",
              {
                key: index,
                staticClass: "mb24 pr10",
                staticStyle: { display: "flex" },
                attrs: { span: 12 },
              },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(_vm._s(item.fieldName) + "："),
                ]),
                item.fieldType === "4" && item.fieldValue
                  ? _c("yxtf-image", {
                      staticStyle: { width: "100px", height: "100px" },
                      attrs: {
                        src: item.fieldValue,
                        "preview-src-list": [item.fieldValue],
                      },
                    })
                  : _c(
                      "yxtf-tooltip",
                      {
                        staticClass: "yxtbiz-register-audit__text",
                        attrs: {
                          placement: "top",
                          "open-filter": true,
                          content: item.fieldValue,
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(item.fieldValue || "--"))])]
                    ),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "standard-size-16 color-gray-10" },
      [
        _c("div", { staticClass: "font-bolder" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pc_biz_sd_register_rule" /**注册规则 */)) +
              "\n    "
          ),
        ]),
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "pr10 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_dept" /**  部门 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  { attrs: { placement: "top", "open-filter": true } },
                  [
                    _c("yxtbiz-dept-name", {
                      attrs: {
                        slot: "content",
                        name: _vm.configEntity.refDeptName,
                      },
                      slot: "content",
                    }),
                    _c("yxtbiz-dept-name", {
                      staticClass: "yxtbiz-board-audit_ellipsis",
                      attrs: { name: _vm.configEntity.refDeptName || "--" },
                    }),
                  ],
                  1
                ),
                _vm.configEntity.refDeptDeleted
                  ? _c(
                      "yxtf-tag",
                      {
                        staticClass: "yxtbiz-register-audit__tag",
                        attrs: { type: "danger", size: "mini" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_biz_kng_lbl_delete" /*删除*/)) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("yxtf-col", { staticClass: "pr10 flex", attrs: { span: 12 } }, [
              _c("span", { staticClass: "color-gray-7 nowrap" }, [
                _vm._v(_vm._s(_vm.$t("biz_udp_usergroup" /**用户组 */)) + "："),
              ]),
              _c(
                "div",
                { staticClass: "yxtbiz-register-audit__groupWrap" },
                [
                  _vm._l(_vm.groupList, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "yxtbiz-register-audit__group",
                      },
                      [
                        _c(
                          "yxtf-tooltip",
                          {
                            staticClass: "yxtbiz-register-audit__text",
                            attrs: {
                              "open-filter": true,
                              placement: "top",
                              content: item.name,
                            },
                          },
                          [_c("div", [_vm._v(_vm._s(item.name))])]
                        ),
                        item.deleted
                          ? _c(
                              "yxtf-tag",
                              {
                                staticClass: "yxtbiz-register-audit__tag",
                                attrs: { type: "danger", size: "mini" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("pc_biz_kng_lbl_delete" /*删除*/)
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  !_vm.groupList.length ? _c("div", [_vm._v("--")]) : _vm._e(),
                ],
                2
              ),
            ]),
          ],
          1
        ),
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "pr10 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_possion" /**岗位 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  { attrs: { "open-filter": true, placement: "top" } },
                  [
                    _c("yxtbiz-position-name", {
                      attrs: {
                        slot: "content",
                        name: _vm.configEntity.refPosiName,
                      },
                      slot: "content",
                    }),
                    _c("yxtbiz-position-name", {
                      staticClass: "yxtbiz-board-audit_ellipsis",
                      attrs: { name: _vm.configEntity.refPosiName || "--" },
                    }),
                  ],
                  1
                ),
                _vm.configEntity.refPosiDeleted
                  ? _c(
                      "yxtf-tag",
                      {
                        staticClass: "yxtbiz-register-audit__tag",
                        attrs: { type: "danger", size: "mini" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_biz_kng_lbl_delete" /*删除*/)) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "yxtf-col",
              { staticClass: "pr10 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("biz_udp_occupation_level" /**职级 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  {
                    staticClass: "yxtbiz-register-audit__text",
                    attrs: {
                      "open-filter": true,
                      placement: "top",
                      content: _vm.configEntity.refGradeName,
                    },
                  },
                  [
                    _c("div", [
                      _vm._v(_vm._s(_vm.configEntity.refGradeName || "--")),
                    ]),
                  ]
                ),
                _vm.configEntity.refGradeDeleted
                  ? _c(
                      "yxtf-tag",
                      {
                        staticClass: "yxtbiz-register-audit__tag",
                        attrs: { type: "danger", size: "mini" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_biz_kng_lbl_delete" /*删除*/)) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }